import dateFormatType from '@/constants/dateFormatType';
import { afterMonths } from '@/utils/time';
import { parse } from 'date-fns';
export default {
    getterSelectedMonth: ({ filterOption }) => filterOption.selectedMonth,
    getterSelectedMonthToTimeStamp: ({ filterOption }) => {
        const dateFormat = dateFormatType.MONTH;
        const dateObject = new Date();
        const selectedMonth = parse(filterOption.selectedMonth, dateFormat, dateObject);
        return [
            selectedMonth.setHours(9, 0, 0, 0),
            afterMonths(selectedMonth, 1).setHours(8, 59, 59, 999),
        ];
    },
};
